import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const PropertyDetails = lazy(() => import('@pages/producer/PropertyDetails'));

export const PropertyDetailsRoutes: RouteObject[] = [
  {
    path: '/property-details',
    element: (
      <React.Suspense>
        <PropertyDetails />
      </React.Suspense>
    ),
  },
];